<template>
  <v-card class="position-relative gray10 h-100" style="">
    <div class="button-group">
      <button
        class="btn buy"
        :class="{ 'success white--text': activeTradeType === 'buy' }"
        @click="activeTradeType = 'buy'"
      >
        {{ $t("exchange.buy") }}
      </button>
      <button
        class="btn sell"
        :class="{ 'error white--text': activeTradeType === 'sell' }"
        @click="activeTradeType = 'sell'"
      >
        {{ $t("exchange.sell") }}
      </button>
    </div>

    <div
      v-if="currentCoin"
      :class="{ 'blur-before-login': !isAuth }"
      class="trade_wrap"
    >
      <div class="d-flex justify-space-between align-center">
        <v-tabs
          show-arrows
          background-color="transparent"
          v-model="tab"
          class="mt-3 trade_menu"
        >
          <v-tab class="font-Medium-14"
            >{{ $t("exchange.limited_price") }}
          </v-tab>
          <v-tab class="font-Medium-14">{{
            $t("exchange.market_price")
          }}</v-tab>
          <v-tab class="font-Medium-14"
            >{{ $t("exchange.stop_order_price") }}
            <v-btn
              icon
              style="color: #FFFFFF"
              @click="showPreconditionalOrderInfoModal = true"
            >
              <v-icon class="ms-1" size="16" clr="var(--v-gray1-base)"
                >$infoIcon
              </v-icon>
            </v-btn>
          </v-tab>
          <v-tab class="font-Medium-14"
            >OCO
            <v-btn
              icon
              style="color: #FFFFFF"
              @click="showOcoOrderInfoModal = true"
            >
              <v-icon class="ms-1" size="16" clr="var(--v-gray1-base)"
                >$infoIcon
              </v-icon>
            </v-btn>
          </v-tab>
        </v-tabs>
      </div>

      <div class="pa-4">
        <limit-order
          v-if="tab === 0"
          :tradeType="activeTradeType"
          :wallet="wallet"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
          ref="form"
          @refresh="refresh"
        />

        <market-order
          v-if="tab === 1"
          :tradeType="activeTradeType"
          :wallet="wallet"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
          @refresh="refresh"
        />

        <precondition-order
          v-if="tab === 2"
          :tradeType="activeTradeType"
          :wallet="wallet"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
          ref="form"
          @refresh="refresh"
        />

        <oco-order
          v-if="tab === 3"
          :tradeType="activeTradeType"
          :wallet="wallet"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
          ref="form"
          @refresh="refresh"
        />
      </div>

      <!-- Precondition Modal -->
      <!-- Oco Modal -->
    </div>
    <div class="absolute-login" v-if="!isAuth">
      <v-btn
        color="primary font-Medium-14"
        @click="$router.push('/auth/login')"
        >{{ $t("authPage.registerPage.signInBeforeLink") }}</v-btn
      >
    </div>
    <PreconditionalOrderInfoModal
      :showModal="showPreconditionalOrderInfoModal"
      @onConfirm="confirmInfo"
    />
    <ocoOrderInfoModal
      :showModal="showOcoOrderInfoModal"
      @onConfirm="confirmInfo"
    />
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import LimitOrder from "@/components/Market/exchange/tradeForms/limitOrder.vue";
import UserCenter from "@/services/modules/market/userCenter";
import marketOrder from "@/components/Market/exchange/tradeForms/marketOrder.vue";
import preconditionOrder from "@/components/Market/exchange/tradeForms/preconditionOrder.vue";
import ocoOrder from "@/components/Market/exchange/tradeForms/ocoOrder.vue";
import PreconditionalOrderInfoModal from "@/components/Market/exchange/tradeForms/preconditionalOrderInfoModal.vue";
import ocoOrderInfoModal from "@/components/Market/exchange/tradeForms/ocoOrderInfoModal.vue";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "index",
  mixins: [authMixin],
  components: {
    ocoOrder,
    preconditionOrder,
    marketOrder,
    LimitOrder,
    PreconditionalOrderInfoModal,
    ocoOrderInfoModal
  },
  data() {
    return {
      showPreconditionalOrderInfoModal: false,
      showOcoOrderInfoModal: false,
      tab: 0,
      wallet: {
        base: 0.0,
        coin: 0.0
      },
      activeTradeType: "buy"
    };
  },
  watch: {
    "currentCoin.symbol": {
      handler(newVal) {
        if (this.isAuth) {
          this.getWalletOnCoin(newVal.split("/")[0]);
          this.getWalletOnBase(newVal.split("/")[1]);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    })
  },
  methods: {
    confirmInfo() {
      this.showPreconditionalOrderInfoModal = false;
      this.showOcoOrderInfoModal = false;
    },
    getWalletOnBase(target) {
      UserCenter.getWallet(target).then(response => {
        if (response.data.data !== null) {
          this.wallet.base = response.data.data.strBalance;
        } else {
          this.wallet.base = 0;
        }
      });
    },
    getWalletOnCoin(target) {
      UserCenter.getWallet(target).then(response => {
        if (response.data.data !== null) {
          this.wallet.coin = response.data.data.strBalance;
        } else {
          this.wallet.coin = 0;
        }
      });
    },
    refresh() {
      this.$emit("refresh");
    }
  }
};
</script>
<style scoped lang="scss">
.absolute-login {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  button {
    width: 200px;
  }
  //transform: translate(-50%);
  @media screen and (min-width: 600px) {
    button {
      width: 200px;
    }
  }
}

.transform-50 {
  transform: translate(50%);
}
</style>
<style lang="scss">
.v-slider__thumb-label {
  transform: translateY(0) translateX(-50%) rotate(45deg) !important;
}

.trade_wrap {
  position: relative;

  .trade_menu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 2px solid var(--v-gray6-base) !important;

    @media (max-width: 700px) {
      height: 50px;
      overflow-x: auto;
    }

    > span {
      min-width: 140px;
      cursor: pointer;

      &.active {
        background-color: #27313e;
        border-bottom: 1px solid #f0a70a;
      }

      @media (max-width: 576px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .info-modal-button {
      display: flex;
      cursor: pointer;
    }
  }

  .trade-type {
    display: none;
    justify-content: center;
    align-items: center;

    .trade-type-buy,
    .trade-type-sell {
      position: relative;
      width: 50%;
      height: 30px;
      line-height: 30px;
    }

    .trade-type-sell {
      background-color: #f15050;
      cursor: pointer;

      &:hover {
        background-color: #f1505f;

        &:after {
          border-right: 15px solid #f1505f;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
        }
      }

      &:after {
        position: absolute;
        content: "";
        border-right: 15px solid #f1505f;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        top: 0;
        left: -14px;
        z-index: 2;
      }
    }

    .trade-type-buy {
      background-color: #00b270;
      cursor: pointer;
      z-index: 1;

      &:hover {
        background-color: #00b27f;
      }
    }
  }

  .mask {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 110;
    color: #ffffff;
  }

  .publish-mask {
    position: absolute;
    height: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 109;
  }
}

.button-group {
  display: flex;
  justify-content: space-between;
  gap: 0px;
  width: 100%;
  padding: 16px;
  .btn {
    position: relative;
    width: 100%;
    font-family: inherit;
    font-size: 18px;
    padding: 10px 24px;
    border: none;
    cursor: pointer;
    border-radius: 6px; // Only round left corners
    overflow: hidden;
    background: none;
    background: var(--v-gray6-base);

    span {
      position: relative;
      z-index: 2;
    }

    &.buy {
      clip-path: polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%);
    }

    &.sell {
      clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 0% 100%);
    }
  }
}

.ltr {
  .button-group {
    .btn {
      &.buy {
        clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 0% 100%);
      }

      &.sell {
        clip-path: polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%);
      }
    }
  }
}
</style>
